export default "__VITE_ASSET__ae039e7b__"